<template>
  <div class="min-h-screen bg-neutral-50">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { onMounted } from 'vue'

const auth = useAuthStore()

onMounted(() => {
  auth.initialize()
})
</script>
